// extracted by mini-css-extract-plugin
module.exports = {"Skills":"Skills_Skills__1uWIW","SkillsSection":"Skills_SkillsSection__3ppgq","Languages":"Skills_Languages__1piS4"};